import toast from "react-hot-toast";
import { Button } from "ui-v2/components/Button";
import { ToastComp } from "ui-v2/components/GenericErrorScreens/ToastComp/ToastComp";
import { ErrorToastProps, ErrorUiTypeEnum } from "ui-v2/types/Error";
import Icon from "../components/Icon/Icon";
import React from "react";

export default function useCustomToast() {
  const showErrToast = ({ errObj, cta, isSticky = false }: ErrorToastProps) => {
    const iconColor =
      {
        [ErrorUiTypeEnum.toast_err]: "negative",
        [ErrorUiTypeEnum.toast_info]: "on_dark_bg",
        [ErrorUiTypeEnum.toast_success]: "positive",
        [ErrorUiTypeEnum.toast_warn]: "alert_dark",
      }[errObj?.ui_type] ?? "on_dark_bg";

    return toast.custom(
      (t) => (
        <ToastComp
          leftIcon={
            !cta && (
              <Icon
                name="InfoCircleBold"
                height={24}
                width={24}
                color={iconColor}
              />
            )
          }
          isVisible={t.visible}
          rightIcon={
            cta && (
              <Button
                variant="ghost_grey"
                label={cta?.label}
                style={{ color: "white" }}
                size="small"
                onClick={() => {
                  cta?.onClick();
                  toast.remove();
                }}
              />
            )
          }
          label={errObj?.title}
        />
      ),
      {
        duration: isSticky ? Infinity : 3500,
      }
    );
  };
  return { showErrToast };
}
